module.exports = __webpack_public_path__ + "82c2a8d89f0551251f28fb406e824182.pdf";